import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import CardElementStickerControl from './CardElementStickerControl';
import { EMOJI_LIB_ENDPOINT } from '../../../../constants/pro-custom-prints';
import { isCardElementEditable } from '../AccountCard/helpers';
import PlusIcon from '../../../../components/icons/PlusIcon';

const propTypes = {
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
    side: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  viewOnly: PropTypes.bool,
};

const CardElementSticker = ({ onChange, element, viewOnly = false }) => {
  const [open, setOpen] = useState(false);
  const { cardElementConfiguration } = element;
  const { system_sticker: systemSticker } = cardElementConfiguration;
  const isEditable = isCardElementEditable(element);

  return (
    <Fragment>
      <div className="card-element-sticker">
        {systemSticker ? (
          <button
            className="card-element-sticker-trigger"
            onClick={() => {
              if (!isEditable || viewOnly) {
                return;
              }

              setOpen(true);
            }}
          >
            <img src={systemSticker.asset_image.url} alt="" />
          </button>
        ) : (
          <button
            className="card-element-sticker-trigger"
            onClick={() => {
              if (!isEditable || viewOnly) {
                return;
              }

              setOpen(true);
            }}
          >
            {!viewOnly && (
              <span className="card-element-sticker-trigger-placeholder">
                <img src={`${EMOJI_LIB_ENDPOINT}/1f600.svg`} alt="" />
                <PlusIcon color="#0d84fe" />
              </span>
            )}
          </button>
        )}
      </div>

      <CardElementStickerControl
        forceOpen={open}
        onClose={() => setOpen(false)}
        onDelete={
          systemSticker
            ? () => {
                onChange(element, {
                  system_sticker_id: null,
                });
              }
            : undefined
        }
        onChange={newSystemSticker => {
          onChange(element, {
            system_sticker_id: newSystemSticker?.id ?? null,
          });
        }}
      />
    </Fragment>
  );
};

CardElementSticker.propTypes = propTypes;

export default CardElementSticker;
